module.exports = __webpack_public_path__ + "static/chinazzi-60fa23f049fc0bfff01622189fa178a5.jpg";